import React, { Component } from 'react';
import Sdk from 'api.digitalpages.module.sdk.api';
import { Preloader } from '../';
import { UsersService } from '../../services/user';
import './sso.css';

export default class SSOV2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true
    };
  }

  componentDidMount() {
    this.handleSSOV2();
  }

  async handleSSOV2() {
    // Limpar todos os dados de autenticação antes do novo SSO
    await this.clearAllAuthData();

    const { connector, valueType, value, state } = this.props.match.params;
    const queryParams = new URLSearchParams(this.props.location.search);
    const path = queryParams.get("path") || "";

    debugger;

    if (!connector || !valueType || !value || !state) {
      this.redirectToLogin();
      return;
    }

    try {
      let data = { connector, state, path };
      data[valueType] = value;

      await this.authenticateSSOFromProvision(data);
    } catch (error) {
      console.error('Erro no SSO V2:', error);
      this.redirectToLogin();
    }
  }

  async clearAllAuthData() {
    console.log('Limpando dados de autenticação...');
    
    try {
      await UsersService.signOut();
      
      // Forçar limpeza completa do SDK
      if (window.Sdk && window.Sdk.Api && window.Sdk.Api.authorization) {
        window.Sdk.Api.authorization.credential = null;
        window.Sdk.Api.authorization.user = null;
        window.Sdk.Api.authorization.activeProject = null;
        delete window.Sdk.Api.authorization.credential;
        delete window.Sdk.Api.authorization.user;
        delete window.Sdk.Api.authorization.activeProject;
      }
      
      // Limpar headers de autorização se existirem
      if (window.Sdk && window.Sdk.Api && window.Sdk.Api.headers) {
        delete window.Sdk.Api.headers.Authorization;
        delete window.Sdk.Api.headers.authorization;
      }
      
      // Disparar evento de logout
      window.dispatchEvent(new Event("@rdpplayer.event(logout)"));
      
    } catch (e) {
      console.log('Erro ao fazer signOut:', e);
    }
    
    console.log('Limpeza concluída');
  }

  async signinProvisionSSO(params) {
    let queryLogin = "";

    ['login', 'cpf', 'email'].forEach(paramName => {
      const loginData = params[paramName];
      if (loginData) queryLogin = `${paramName}=${loginData}`;
    });

    if (!queryLogin.length) throw new Error("Login não encontrado em query params");

    const url = `auth/v1.1/provisioning/user/connector/uid/${params.connector}/sso?state=${params.state}&${queryLogin}`;

    const result = await Sdk.Api.dynamic.bridge(url, null, 'POST');

    if (result.access_token) {
      await Sdk.Api.authorization.signinByCredential(result);

      // Aguardar o SDK popular user/credential antes de navegar (mesma causa do SSO v1)
      await this.waitForSdkReady();

      const user = await Sdk.Api.authorization.userInfo();

      UsersService.setUser(JSON.stringify(user));

      window.location.hash = '/';
    }

    return false;
  }

  async authenticateSSOFromProvision(params) {
    try {
      await this.signinProvisionSSO(params);

      // Redirecionar para o path especificado
      window.location.hash = params.path || '/';
    } catch (error) {
      console.error('Erro na autenticação SSO V2:', error);
      debugger;
      this.redirectToLogin();
    }
  }

  async waitForSdkReady(maxAttempts = 30, intervalMs = 300) {
    for (let attempt = 0; attempt < maxAttempts; attempt++) {
      const { user, credential } = Sdk.Api.authorization;

      if (user && user.uid && credential && credential.accessToken) {
        return true;
      }

      try {
        if (typeof Sdk.Api.authorization.updateUserInfoAndPermissions === 'function') {
          await Sdk.Api.authorization.updateUserInfoAndPermissions();
        }
      } catch (e) {
        console.warn('waitForSdkReady: falha ao atualizar usuário', e);
      }

      await new Promise(resolve => setTimeout(resolve, intervalMs));
    }

    return false;
  }

  redirectToLogin() {
    window.location.hash = '/login';
  }

  render() {
    return (
      <div className="rdp-react-template-view-sso-v2">
        <Preloader show={this.state.loading} />
      </div>
    );
  }
}